import {
  AlarmNotificationProfileState,
  AlarmNotificationProfileActionTypes,
  GET_ALARM_NOTIFICATION_PROFILE_LIST,
  GET_ALARM_NOTIFICATION_PROFILE_LIST_FULFILLED,
  GET_ALARM_NOTIFICATION_PROFILE_PENDING,
  GET_ALARM_NOTIFICATION_PROFILE_FULFILLED,
  GET_INTERCEPT_ALARM_LIST_FULFILLED,
  GET_ALARMS_INST_LIST_FULFILLED,
  GET_ALARMS_DEF_LIST_FULFILLED,
  SELECT_ALARM_NOTIFICATION_PROFILE,
  CREATE_ALARM_NOTIFICATION_PROFILE_PENDING,
  CREATE_ALARM_NOTIFICATION_PROFILE_FULFILLED,
  DELETE_ALARM_NOTIFICATION_PROFILE_FULFILLED,
  SET_ALARM_NOTIFICATION_PROFILE_LOADING,
} from './alarmNotificationProfile.types';

export const initialState: AlarmNotificationProfileState = {
  entities: [],
  selected: [],
  single: null,
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  },
  interceptAlarmList: [],
  alarmsInstList: [],
  alarmsDefList: [],
};

export default function alarmNotificationProfileReducer(
  state = initialState,
  action: AlarmNotificationProfileActionTypes,
): AlarmNotificationProfileState {
  switch (action.type) {
    case GET_ALARM_NOTIFICATION_PROFILE_LIST:
      return {
        ...state,
        selected: [],
      };

    case GET_ALARM_NOTIFICATION_PROFILE_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: [],
      };

    case GET_ALARM_NOTIFICATION_PROFILE_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_ALARM_NOTIFICATION_PROFILE_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };

    case SELECT_ALARM_NOTIFICATION_PROFILE:
      return {
        ...state,
        selected: action.payload || [],
      };

    case CREATE_ALARM_NOTIFICATION_PROFILE_PENDING:
      return {
        ...state,
        createdId: null,
      };

    case CREATE_ALARM_NOTIFICATION_PROFILE_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case DELETE_ALARM_NOTIFICATION_PROFILE_FULFILLED:
      return {
        ...state,
        selected: [],
      };

    case SET_ALARM_NOTIFICATION_PROFILE_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    case GET_INTERCEPT_ALARM_LIST_FULFILLED:
      return {
        ...state,
        interceptAlarmList: action.payload.data.data ?? [],
      };

    case GET_ALARMS_INST_LIST_FULFILLED:
      return {
        ...state,
        alarmsInstList: action.payload.data.data ?? [],
      };

    case GET_ALARMS_DEF_LIST_FULFILLED:
      return {
        ...state,
        alarmsDefList: action.payload.data.data ?? [],
      };

    default:
      return state;
  }
}
